import translator from "@/translator";
import React, { useEffect, useState } from "react";
import { Button, Card, message, Spin } from "antd";
import BackButton from "@/note_office/shared/BackButton";
import CustomPagination from "@/note_office/shared/CustomPagination";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { useClientContactsState } from "../State";

const t = translator("note_office.views.bulk_deliveries.template_view.");

const TemplateView = () => {
  const navigate = useNavigate();
  const { state, updateState } = useClientContactsState();
  const { templates_url } = state.bulkDeliveriesData || {};

  const [currentPage, setCurrentPage] = useState(1);
  const [templates, setTemplates] = useState([]);
  const [loading, setLoading] = useState(false);
  const [perPage, setPerPage] = useState(8);
  const [totalTemplates, setTotalTemplates] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [selectedTemplateId, setSelectedTemplateId] = useState(null);

  useEffect(() => {
    loadTemplates();
  }, [currentPage]);

  const loadTemplates = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${templates_url}?page=${currentPage}&per_page=${perPage}`);

      setTemplates(data.templates || []);
      setPerPage(data.per_page);
      setTotalTemplates(data.total_templates);
      setTotalPages(data.total_pages);
    } catch (error) {
      console.error(error);
      message.error(t("errors.server_error"));
    } finally {
      setLoading(false);
    }
  };

  const handleSelectTemplate = () => {
    const selected = templates.find((t) => t.id === selectedTemplateId);
    if (selected) {
      updateState({ selectedTemplateText: selected.text, selectedChannels: selected.channels });
      navigate("/create");
    }
  };

  return (
    <div className="wrapper wrapper__menu-layout overflow">
      <BackButton onClick={() => navigate("/")} text={t("title")} />

      {!totalTemplates ? (
        <div className="empty-state">{t("no_templates")}</div>
      ) : (
        <>
          <div className="bulk_deliveries__card-container overflow">
            {templates.map((template) => (
              <Card
                key={template.id}
                className={`bulk_deliveries__card ${selectedTemplateId === template.id ? "selected-template" : ""}`}
                onClick={() => setSelectedTemplateId(template.id)}
              >
                <div className="bulk_deliveries__details-template">
                  <span className="bulk_deliveries__label">{t("channel_label")}:</span>
                  <span className="bulk_deliveries__text">
                    {["whatsapp", "sms"]
                      .filter((channel) => template.channels?.[channel])
                      .join(" / ")}
                  </span>
                </div>

                <div className="bulk_deliveries__details-template bulk_deliveries__details-last">
                  <span className="bulk_deliveries__label">{t("text_label")}:</span>
                  <span className="bulk_deliveries__fulltext">{template.text}</span>
                </div>
              </Card>
            ))}
          </div>

          {loading && <Spin size="large" className="loader" />}

          {totalPages > 1 && (
            <CustomPagination
              current={currentPage}
              total={totalTemplates}
              pageSize={perPage}
              onChange={setCurrentPage}
            />
          )}

          <div className="button-group">
            <Button
              type="primary"
              block
              className="button-base"
              onClick={handleSelectTemplate}
              disabled={!selectedTemplateId}
            >
              {t("choose_template")}
            </Button>
          </div>
        </>
      )}
    </div>
  );
};

export default TemplateView;
